import { useQuery } from "@tanstack/react-query";

import { getBettingMarketMappings } from "@/api/bettingMarkets";
import { BettingMarketsQueryKeys } from "./bettingMarketsQueryKeys";

export const useBettingMarketMappings = (marketId: number | null) => {
  return useQuery({
    queryKey: [BettingMarketsQueryKeys.BettingMarketMappings, marketId],
    queryFn: ({ signal }) => getBettingMarketMappings(marketId!, { signal, params: {} }),
    enabled: marketId !== null,
  });
};
